import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["edges", "totalCount", "fetchMoreResponses", "useScrollToFocused"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box } from '@mui/material';
import * as A from 'fp-ts/Array';
import * as Num from 'fp-ts/number';
import * as Ord from 'fp-ts/Ord';
import { useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import PublicResponseItem from './public-response-item';
import ResponsePlaceholder from './response-placeholder';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var within10 = Ord.clamp(Num.Ord)(0, 10);
export var ResponsesPlaceholder = function ResponsesPlaceholder(_ref) {
  var count = _ref.count;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: A.makeBy(count, function (i) {
      return /*#__PURE__*/_jsx(ResponsePlaceholder, {}, i);
    })
  });
};

var shouldFetchMoreResponses = function shouldFetchMoreResponses(focusedId, edges, totalCount) {
  return focusedId && edges.length !== totalCount && edges.every(function (response) {
    return response.id !== focusedId;
  });
};

export var FocusedPublicResponsesList = function FocusedPublicResponsesList(_ref2) {
  var edges = _ref2.edges,
      totalCount = _ref2.totalCount,
      fetchMoreResponses = _ref2.fetchMoreResponses,
      useScrollToFocused = _ref2.useScrollToFocused,
      publicResponsesProps = _objectWithoutProperties(_ref2, _excluded);

  var _useScrollToFocused = useScrollToFocused(),
      shouldHighlight = _useScrollToFocused.shouldHighlight,
      focusedRef = _useScrollToFocused.focusedRef,
      focusedResponseId = _useScrollToFocused.focusedResponseId,
      focusedCommentId = _useScrollToFocused.focusedCommentId;

  useEffect(function () {
    if (shouldFetchMoreResponses(focusedResponseId, edges, totalCount)) {
      fetchMoreResponses();
    }
  }, [focusedResponseId, fetchMoreResponses, edges, totalCount]);
  return /*#__PURE__*/_jsx(PublicResponsesList, _objectSpread(_objectSpread({
    edges: edges,
    totalCount: totalCount,
    fetchMoreResponses: fetchMoreResponses,
    shouldHighlight: shouldHighlight,
    focusedRef: focusedRef,
    focusedResponseId: focusedResponseId !== null && focusedResponseId !== void 0 ? focusedResponseId : undefined,
    focusedCommentId: focusedCommentId !== null && focusedCommentId !== void 0 ? focusedCommentId : undefined,
    useScrollToFocused: useScrollToFocused
  }, publicResponsesProps), {}, {
    "data-element": "PublicResponsesList",
    "data-component": "FocusedPublicResponsesList",
    "data-source-file": "public-responses-list.tsx"
  }));
};

var PublicResponsesList = function PublicResponsesList(_ref3) {
  var _edges$length;

  var useScrollToFocused = _ref3.useScrollToFocused,
      fetchMoreResponses = _ref3.fetchMoreResponses,
      edges = _ref3.edges,
      totalCount = _ref3.totalCount,
      hasNextPage = _ref3.pageInfo.hasNextPage,
      profile = _ref3.profile,
      focusedResponseId = _ref3.focusedResponseId,
      focusedCommentId = _ref3.focusedCommentId,
      focusedRef = _ref3.focusedRef,
      shouldHighlight = _ref3.shouldHighlight;
  return /*#__PURE__*/_jsx(InfiniteScroll, {
    scrollableTarget: 'publicResponsesScroll',
    dataLength: (_edges$length = edges.length) !== null && _edges$length !== void 0 ? _edges$length : 0,
    next: fetchMoreResponses,
    hasMore: hasNextPage,
    loader: /*#__PURE__*/_jsx(ResponsesPlaceholder, {
      count: within10(totalCount - edges.length)
    }),
    "data-element": "InfiniteScroll",
    "data-component": "PublicResponsesList",
    "data-source-file": "public-responses-list.tsx",
    children: edges.map(function (response) {
      var isFocusedResponse = response.id === focusedResponseId && !focusedCommentId;
      return /*#__PURE__*/_jsx(Box, {
        sx: {
          mb: 2,
          display: 'flex'
        },
        ref: isFocusedResponse ? focusedRef : undefined,
        children: /*#__PURE__*/_jsx(PublicResponseItem, {
          publicResponse: response,
          profile: profile,
          isFocused: isFocusedResponse && shouldHighlight,
          useScrollToFocused: useScrollToFocused,
          hasFocusedComment: response.id === focusedResponseId && !!focusedCommentId
        })
      }, response.id);
    })
  });
};

export default PublicResponsesList;